import React from "react";
import CountUp from "react-countup";
import { FaCar, FaWrench, FaSmile, FaUserClock } from 'react-icons/fa';

const Statistics = () => {
  return (
    <section className="statistics-section bg-purple-100 py-10">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="text-center p-4">
            <div className="bg-purple-500 rounded-full p-3 inline-block">
              <FaCar size={32} color="white" />
            </div>
            <h3 className="text-2xl font-bold mb-2">
              <CountUp end={100} duration={30} separator="," />
            </h3>
            <p className="text-gray-600">Available Cars</p>
          </div>
          <div className="text-center p-4">
            <div className="bg-purple-500 rounded-full p-3 inline-block">
              <FaWrench size={32} color="white" />
            </div>
            <h3 className="text-2xl font-bold mb-2">
              <CountUp end={100} duration={30} suffix="%" />
            </h3>
            <p className="text-gray-600">Service Delivery</p>
          </div>
          <div className="text-center p-4">
            <div className="bg-purple-500 rounded-full p-3 inline-block">
              <FaSmile size={32} color="white" />
            </div>
            <h3 className="text-2xl font-bold mb-2">
              <CountUp end={100} duration={30} suffix="%" />
            </h3>
            <p className="text-gray-600">Users Satisfaction</p>
          </div>
          <div className="text-center p-4">
            <div className="bg-purple-500 rounded-full p-3 inline-block">
              <FaUserClock size={32} color="white" />
            </div>
            <h3 className="text-2xl font-bold mb-2">
              <CountUp end={24} duration={30} suffix="hrs" />
            </h3>
            <p className="text-gray-600">Customer Service</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Statistics;
